export type PortfolioCategory = 'all' | 'web' | 'tools' | 'ecommerce';

export type PortfolioProject = {
  id: string;
  src?: string;
  website: string;
  category: Exclude<PortfolioCategory, 'all'>;
  tech: string[];
  accent: string;
};

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 'steny',
    src: '/assets/portfolio/prj-steny.webp',
    website: 'https://stenyorganic.com/',
    category: 'ecommerce',
    tech: ['Web', 'E-commerce'],
    accent: '#2F6B4F',
  },
  {
    id: 'god-of-decisions',
    src: '/assets/portfolio/prj-god-of-decisions.webp',
    website: 'https://god-of-decisions.vercel.app/',
    category: 'tools',
    tech: ['React', 'TypeScript'],
    accent: '#4C5FD7',
  },
  {
    id: 'flip-book',
    src: '/assets/portfolio/prj-flip-book.webp',
    website: 'https://flip-book-nu.vercel.app/',
    category: 'tools',
    tech: ['React', 'Animation'],
    accent: '#C45C26',
  },
];
